var BrowserStorage;
(function (BrowserStorage) {
    BrowserStorage["ProjectId"] = "projectId";
    BrowserStorage["UserId"] = "userId";
    BrowserStorage["AuthToken"] = "authToken";
})(BrowserStorage || (BrowserStorage = {}));
export default BrowserStorage;
